import React, { useState } from "react";

// Page de test pour simuler une erreur
function TestErrorPage() {
    const [shouldError, setShouldError] = useState(false);

    if (shouldError) {
        // Ceci va déclencher l'ErrorBoundary
        throw new Error("Erreur de test simulée !");
    }

    return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50">
            <h1 className="text-2xl font-bold mb-4">🧪 Page de test d'erreur</h1>
            <p className="text-gray-600 mb-6 text-center">
                Cliquez sur le bouton pour simuler une erreur JavaScript
                et voir la page d'erreur personnalisée.
            </p>
            <button
                onClick={() => setShouldError(true)}
                className="bg-red-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-600 transition-colors"
            >
                💥 Déclencher une erreur
            </button>
        </div>
    );
}

export default TestErrorPage;